<template>
  <div class="d-flex justify-content-between">
    <h3 class="h5">{{title}}</h3>
    <small>
      {{selectedCount}}/{{totalCount}}
    </small>
  </div>
</template>

<script>
 export default {
   props: [
     'title',
     'selectedCount',
     'totalCount',
   ],
 }
</script>



// WEBPACK FOOTER //
// assets/js/components/work-logs/FilterHeader.vue